import { extendTailwindMerge, validators } from 'tailwind-merge';

type HitSlopClassGroupId =
    | 'hit-slop-base'
    | 'hit-slop-all'
    | 'hit-slop-x'
    | 'hit-slop-y'
    | 'hit-slop-t'
    | 'hit-slop-r'
    | 'hit-slop-b'
    | 'hit-slop-l'
    | 'hit-slop-s'
    | 'hit-slop-e';

const semanticSpacingThemeValues = [
    'none',
    'xxs',
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    '2xl',
    '3xl',
    '4xl',
    '5xl',
    '6xl',
    '7xl',
    '8xl',
    '9xl',
    '10xl',
    '11xl',
];

const hitSlopThemeValues = [...semanticSpacingThemeValues, validators.isArbitraryValue];

const twMerge = extendTailwindMerge<HitSlopClassGroupId>({
    extend: {
        theme: {
            spacing: semanticSpacingThemeValues,
            text: [
                'display-xs',
                'display-sm',
                'display-md',
                'display-lg',
                'display-xl',
                'display-2xl',
                'display-3xl',
                'display-4xl',
                'display-5xl',
                'display-6xl',
            ],
        },
        classGroups: {
            'hit-slop-base': ['hit-slop'],
            'hit-slop-all': [{ 'hit-slop': hitSlopThemeValues }],
            'hit-slop-x': [{ 'hit-slop-x': hitSlopThemeValues }],
            'hit-slop-y': [{ 'hit-slop-y': hitSlopThemeValues }],
            'hit-slop-t': [{ 'hit-slop-t': hitSlopThemeValues }],
            'hit-slop-r': [{ 'hit-slop-r': hitSlopThemeValues }],
            'hit-slop-b': [{ 'hit-slop-b': hitSlopThemeValues }],
            'hit-slop-l': [{ 'hit-slop-l': hitSlopThemeValues }],
            'hit-slop-s': [{ 'hit-slop-s': hitSlopThemeValues }],
            'hit-slop-e': [{ 'hit-slop-e': hitSlopThemeValues }],
        },
        conflictingClassGroups: {
            'hit-slop-all': [
                'hit-slop-x',
                'hit-slop-y',
                'hit-slop-t',
                'hit-slop-r',
                'hit-slop-b',
                'hit-slop-l',
                'hit-slop-s',
                'hit-slop-e',
            ],
            'hit-slop-x': ['hit-slop-r', 'hit-slop-l'],
            'hit-slop-y': ['hit-slop-t', 'hit-slop-b'],
        },
    },
});

/**
 * This function is a wrapper around the twMerge function.
 * It is used to merge the classes inside style objects.
 */
export const cx = twMerge;

/**
 * This function does nothing besides helping us to be able to
 * sort the classes inside style objects which is not supported
 * by the Tailwind IntelliSense by default.
 */
export function sortCx<
    T extends Record<string, string | number | Record<string, string | number | Record<string, string | number>>>,
>(classes: T): T {
    return classes;
}
